<template>
  <div v-if="list_options && list_options.length > 0">
    <div class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 py-2 radius-bottom mt-5">
      <v-icon :icon="mainStore.billetterie_mode ? 'mdi-ticket' : 'mdi-star-plus-outline'" color="darkblue"
        size="32"></v-icon>
      <div class="text-h5 font-weight-bold">{{ mainStore.billetterie_mode ? 'Billetterie' : 'Les options' }}</div>
    </div>
    <v-row>
      <v-col>
        <div v-for="group in list_options_grouped" :key="group.name">
          <div v-if="group.name == 'Sans groupe'">
            <div v-for="option in group.list" :key="option.id">
              <OptionItem :option="option" :all_options="all_options" :key="option.id"></OptionItem>
            </div>
          </div>
          <div v-else>
            <div class="text-h6 font-weight-bold  mt-6">{{ group.name }}</div>
            <OptionItem v-for="option in group.list" :option="option" :all_options="all_options" :key="option.id">
            </OptionItem>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import OptionItem from "@/components/Home/Options/Option_Item.vue";

export default {
  components: { OptionItem },
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useMainStore),
    all_options() {
      return this.mainStore.module.options.list;
    },
    list_options() {
      return this.mainStore.module.options.visibles_accueil;
    },
    list_options_grouped() {
      return this.mainStore.module.options.visibles_accueil_grouped;
    }
  },
};
</script>

<style lang="scss" scoped></style>